module.exports = __webpack_public_path__ + "img/benabar.96bcdbb5.jpg";